export default __webpack_public_path__ + "media/fonts/FormaDJRMicro-Bold.woff";